/**
 * @ngdoc function
 * @name lmApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the lmApp
 */
lmApp.controller('GreetingsController', ['$scope', '$location', '$rootScope', '$routeParams', '$timeout', '$interval', 'GreetingsService',
  function ($scope, $location, $rootScope, $routeParams, $timeout, $interval, GreetingsService) {

    $scope.smallPreloaderIndex = 0;
    $scope.preloaderIndex = 0;
    $scope.preloaderMessages = [
      {
        image: '/images/message-0.png',
        title: 'Welcome to SotalCloud',
        text: 'your brand new video content distribution space! In just few steps you will unleash power of DRM protected unlimited content distribution for movies, events and linear channels on most popular connected devices!'
      },
      {
        image: '/images/message-1.png',
        title: '',
        text: 'Sell movies, series, pack them into bundles or sell one by one! Want to give away for free - its also an option to boost your project\'s audience.'
      },
      {
        image: '/images/message-2.png',
        title: '',
        text: 'Events or Linear channels - live, recorded in CatchUp or by users NPVR! Automated bandwidth management will deliver best quality to any part of the world.'
      },
      {
        image: '/images/message-3.png',
        title: '',
        text: 'Make decision and adjust your business instantly with our intuitive analytics and consumption statistics. Get most out your business!'
      },
      {
        image: '/images/message-4.png',
        title: '',
        text: 'Grow with no limits. Automatic content distribution to CDNs or SotalCloud private CDN, cloud based content encoding with DRM support. From few to few million of subscribers - SotalCloud your trusted partner!'
      }
    ];

    $scope.activationFormData = {
      code: '',
      loading: false,
      isActivationComplete: false,
      error: '',
      /**
       * Check activation code
       */
      checkCode: function () {
        if (this.loading) return;

        if (!this.code) {
          this.error = 'Input activation code';
          return;
        }

        this.loading = true;

        $rootScope.showLinearProgress('#greetingsLoader');

        this.error = '';

        GreetingsService.Confirm($scope.activationFormData.code)
          .then(function (response) {
            $rootScope.hideLinearProgress('#greetingsLoader');
            $scope.activationFormData.loading = false;
            $scope.activationFormData.isActivationComplete = true;

            $scope.intPreloadSmall = $interval(function () {
              $scope.newIndex = $scope.smallPreloaderIndex + 1;
              $timeout(function () {
                if ($scope.newIndex < 4) {
                  $scope.smallPreloaderIndex = $scope.newIndex
                } else {
                  $scope.smallPreloaderIndex = 0;
                }
              });
            }, 650);

            $scope.intPreload = $interval(function () {
              $scope.newIndex_ = $scope.preloaderIndex + 1;
              $timeout(function () {
                $scope.newIndex_ < 5 ? $scope.preloaderIndex = $scope.newIndex_ : $rootScope.go('/enter');
              });
            }, 18 * 1000);
          }, function (reason) {
            $rootScope.hideLinearProgress('#greetingsLoader');
            $scope.activationFormData.loading = false;
            if (reason.message === 'Invalid code') {
              $scope.activationFormData.error = 'Wrong activation code.';
            } else {
              $rootScope.debugInfo(reason);
            }
          });
      }
    };

    /**
     * Get activation code from url
     */
    if ($location.path().split('/')[2]) {
      $scope.activationFormData.code = $location.path().split('/')[2];
      $scope.activationFormData.checkCode();
    }

    if ($routeParams.mystery) {
      $scope.activationFormData.isActivationComplete = true;

      $scope.intPreloadSmall = $interval(function () {
        $scope.newIndex = $scope.smallPreloaderIndex + 1;
        $timeout(function () {
          if ($scope.newIndex < 4) {
            $scope.smallPreloaderIndex = $scope.newIndex
          } else {
            $scope.smallPreloaderIndex = 0;
          }
        });
      }, 650);

      $scope.intPreload = $interval(function () {
        $scope.newIndex_ = $scope.preloaderIndex + 1;
        $timeout(function () {
          $scope.newIndex_ < 5 ? $scope.preloaderIndex = $scope.newIndex_ : $scope.preloaderIndex = 0;
        });
      }, 18 * 1000);
    }

    $scope.$on('$destroy', function () {
      if ($scope.intPreloadSmall) $interval.cancel($scope.intPreloadSmall);
      if ($scope.intPreload) $interval.cancel($scope.intPreload);
    });
  }]);
